/* eslint-disable no-shadow */
const React = require('react');
const PropTypes = require('prop-types');
const { wrapFunctionalComponent } = require('utils/framework').default;
const getBaseComponent = require('utils/framework/getBaseComponent').default;
const getStyledComponent = require('utils/framework/getStyledComponent').default;
const {
    compose, color, layout, space, typography
} = require('styled-system');
const theme = require('style/theme');

const StyledComponent = getStyledComponent({
    InnerComp: getBaseComponent({
        elementType: 'span',
        isBasicElement: false,
        useRef: true
    }),
    styledProps: [
        props => [
            styles.base,
            props.numberOfLines && [props.numberOfLines === 1 ? styles.textOneLine : styles.textMultiLine, { WebkitLineClamp: props.numberOfLines }],
            props.baseCss,
            compose(color, layout, space, typography),
            props.css
        ]
    ]
});

const Text = React.forwardRef((props, ref) => {
    return (
        <StyledComponent
            __ref={ref}
            {...props}
        />
    );
});

Text.propTypes = {
    // Max number of displayed lines; requires block element type or display
    numberOfLines: PropTypes.number
};

Text.defaultProps = {
    theme
};

const styles = {
    base: {
        whiteSpace: 'pre-wrap',
        wordWrap: 'break-word'
    },
    textOneLine: {
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    },
    textMultiLine: {
        display: '-webkit-box !important',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        WebkitBoxOrient: 'vertical'
    }
};

module.exports = wrapFunctionalComponent(Text, 'Text');
